var MessageDialog = /** @class */ (function () {
    function MessageDialog() {
        this.selector = '#messageDialog';
        this.$element = $(this.selector);
    }
    MessageDialog.prototype.show = function (title, text) {
        var _a;
        $("".concat(this.selector, " .dialog-text")).text(text);
        (_a = this.$element.kendoWindow({
            width: "600px",
            title: title,
            visible: false,
            actions: ["Close"],
            modal: true
        }).data("kendoWindow")) === null || _a === void 0 ? void 0 : _a.title(title).center().open();
    };
    MessageDialog.prototype.showHtml = function (title, text) {
        var _a;
        $("".concat(this.selector, " .dialog-text")).html(text);
        (_a = this.$element.kendoWindow({
            width: "600px",
            title: title,
            visible: false,
            actions: ["Close"],
            modal: true
        }).data("kendoWindow")) === null || _a === void 0 ? void 0 : _a.title(title).center().open();
    };
    MessageDialog.prototype.showMobile = function (title, text) {
        var _a;
        $("".concat(this.selector, " .dialog-text")).html(text);
        (_a = this.$element.kendoWindow({
            width: "300px",
            title: title,
            visible: false,
            actions: ["Close"],
            modal: true
        }).data("kendoWindow")) === null || _a === void 0 ? void 0 : _a.title(title).center().open();
    };
    MessageDialog.prototype.clear = function () {
        $("".concat(this.selector, " .dialog-text")).html('');
    };
    MessageDialog.prototype.close = function () {
        var _a;
        (_a = $('#messageDialog').data("kendoWindow")) === null || _a === void 0 ? void 0 : _a.close(); //addClass('hidden');
    };
    return MessageDialog;
}());
export { MessageDialog };
